import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverSurfaceEmptyDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignItems: "center"
    },
    text: {
        textAlign: "center"
    }
});

export const useStyles = ({
    spaces
}: PopoverSurfaceEmptyDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: spaces.spacingMd,
            paddingVertical: spaces.spacingLg,
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
